<template>
  <div class="h-100">
    <component
      :is="mapType"
      :alarm="alarm"
      :units="units"
      :unit_id="unit_id"
      :data="data"
      :tabInfo="tabInfo"
      :isCard="isCard"
      v-on="$listeners"
     />
  </div>
</template>

<script>
import unitsMap from "./unitsMap.vue";
import unitsMapTracking from "./unitsMapTracking.vue";
import store from "@/store";

export default {
  props: {
    alarm: {
      type: Object,
    },
    unit_id: {
      type: String | Number,
    },
    data: {
      type: Object,
      default: null,
    },
    tabInfo: Object,
    isCard: {
      type: Boolean,
      default: false,
    },
    singleUnit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    unitsMap,
    unitsMapTracking,
  },
  computed: {
    units() {
      const units = store.state.grid.units;

      if (!this.singleUnit || !this.unit_id) return units;

      return units.filter((u) => String(u.id) === String(this.unit_id));
    },
    unit() {
      return this.units.find((u) => u.id === this.unit_id);
    },
    mapType() {
      return this.unit && this.unit.vehicle ? 'units-map-tracking' : 'units-map';
    },
  },
};
</script>

<style lang="scss">
.dark-layout .gm-style .gm-style-iw-c {
  background-color: #282f46;
}
</style>

<style lang="scss">
.omniview-map {
  width: 100%;
  height: 100%;
}
</style>
